module.exports = __webpack_public_path__ + "static/media/doctors-visit.44eda359.md";


//////////////////
// WEBPACK FOOTER
// ./src/md/doctors-visit.md
// module id = 2885
// module chunks = 0